import React, { useState, useEffect } from 'react';
import { auth } from '../../firebase';
import { signOut } from "@firebase/auth";
import { Link } from 'react-router-dom';
import './login_signup.css';

function UnverifiedPage() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(false);
  }, []);

  const handleLogout = async () => {
    await signOut(auth);
    window.location.href = '/'; // Redirect to home or login
  };

  if (loading) {
    return (
      <div className="admin-login-bg">
        <div className="admin-login-card">
          <div className="admin-login-loading">
            <div className="admin-login-spinner"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-login-bg">
      <div className="admin-login-card">
        <h1 className="admin-login-title">Admin Portal</h1>
        <div className="admin-login-error" style={{ marginBottom: "1.5rem" }}>
          <svg className="admin-login-error-icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none"/>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4m0 4h.01" />
          </svg>
          <span>Your profile has not yet been verified. Please check back here after your profile is verified.</span>
        </div>
        <button
          className="admin-login-btn"
          style={{ marginTop: "0.5rem" }}
          onClick={handleLogout}
        >
          Logout
        </button>
      </div>
    </div>
  );
}

export default UnverifiedPage;